import { render, staticRenderFns } from "./DetailSim.vue?vue&type=template&id=17ee0325&scoped=true"
import script from "./DetailSim.vue?vue&type=script&lang=js"
export * from "./DetailSim.vue?vue&type=script&lang=js"
import style0 from "./DetailSim.vue?vue&type=style&index=0&id=17ee0325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee0325",
  null
  
)

export default component.exports